import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { WorkflowTemplate } from 'app/models/workflow-template';
import { Globals } from 'app/services/globals'
import { WorkflowStepCompletion } from 'app/models/workflow-step-completion';
import { WorkflowAutoUpload } from 'app/models/workflow-auto-upload';
import { WorkflowAutoEmail } from 'app/models/workflow-auto-email';

@Injectable({ providedIn: 'root' })
export class WorkflowAutoUploadService {

    constructor(private http: HttpClient, private globals: Globals) { }
    
    addWorkflowAutoUpload(workflowStepCompletionId: number, rule: WorkflowAutoUpload){
        return this.http.post<WorkflowAutoUpload>(`${this.globals.api_base_url}/workflow-step-completion/${workflowStepCompletionId}/auto-upload`, rule);
    }
    
    getWorkflowAutoUploads(workflowStepCompletionId: number,){
        return this.http.get<WorkflowAutoUpload[]>(`${this.globals.api_base_url}/workflow-step-completion/${workflowStepCompletionId}/auto-uploads`);
    }
    
    editWorkflowAutoUpload(rule: WorkflowAutoUpload){
        return this.http.put<WorkflowAutoUpload[]>(`${this.globals.api_base_url}/workflow-auto-upload/${rule.id}`, rule);
    }
    
    deleteWorkflowAutoUpload(ruleId: number){
        return this.http.delete<WorkflowAutoUpload[]>(`${this.globals.api_base_url}/workflow-auto-upload/${ruleId}`);
    }
    

}